import Enum from "../../enum";
import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../constants";

export const memberSchema = {
    "member": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "externalStateId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_STATE_ID,
            value: "",
        },
        "externalStateName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_STATE_NAME,
            value: "",
        },
        "externalUpdatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "email": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EMAIL,
            value: "",
        },
        "phone": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.PHONE,
            value: "",
        },
        "cellPhone": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CELL_PHONE,
            value: "",
        },
        "address": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ADDRESS,
            value: "",
        },
        "birthDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
            format: "YYYY. MM. DD",
            communication: COMMUNICATION_FORMAT.DATE,

        },
        "joinDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "quitDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "profileUrl": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.URL,
            value: "",
        },
        "role": {
            type: DATA_TYPE.ENUM,
            enum: "MemberRole",
            value: Enum.BE_MEMBER_ROLE.MEMBER,
        },
        "state": {
            type: DATA_TYPE.ENUM,
            enum: "MemberState",
            value: Enum.BE_MEMBER_STATE.ACTIVE,
        },
        "userId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "number": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NUMBER,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "department": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "externalUpdatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "code": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CODE,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "order": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "startDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "endDate": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DATE,
            value: "",
        },
        "parentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        // BE 조립분 — departmentMember(연결 엔티티)의 필드이고 department aggregate 에는 없다.
        // member saga Assembler 가 부서 항목마다 얹는다 (DEPARTMENT_HEAD | DEPARTMENT_MEMBER)
        "role": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CODE,
            value: "",
        }
    },

    "label": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "code": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.CODE,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "color": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.COLOR,
            value: "",
        },
        "order": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "type": {
            type: DATA_TYPE.ENUM,
            enum: "LabelType",
            value: Enum.BE_LABEL_TYPE.NONE,
        },
        "enabledRemark": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "deletedParticipant": {
        "memberId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "memberNumber": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NUMBER,
            value: "",
        },
        "memberName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "memberProfileUrl": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.URL,
            value: "",
        },
        "memberRole": {
            type: DATA_TYPE.ENUM,
            enum: "MemberRole",
            value: null,
        },
        "memberState": {
            type: DATA_TYPE.ENUM,
            enum: "MemberState",
            value: null,
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "departmentName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "departmentMemberRole": {
            type: DATA_TYPE.ENUM,
            enum: "DepartmentMemberRole",
            value: null,
        },
        "actedRole": {
            type: DATA_TYPE.ENUM,
            enum: "ActedRole",
            value: null,
        },
    }
} as const;
